import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "timer" }
const _hoisted_2 = { class: "buttons" }

import TimerRings from '@/components/TimerRings.vue'
import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import NoSleep from 'nosleep.js'
import { useTimer } from '@/composables/useTimer'
import { useSound } from '@/composables/useSound'
import { useBackground, BackgroundThemes } from '@/composables/useBackground'


export default /*@__PURE__*/_defineComponent({
  __name: 'TimerView',
  setup(__props) {

const router = useRouter()
const { backgroundTheme } = useBackground()
const { totalTimeMs, exercises, workMs, restMs, time2Str, rest } = useTimer()
const { tickShort, tickLong, tickFinal } = useSound()

const noSleep = new NoSleep()
const isRunning = ref(false)
const innerVal = ref(0)
const outerVal = ref(0)

const interval = ref(0)
const startTs = ref(0)
const millesMem = ref(0)

const exerciseNum = ref(0)
const isWork = ref(false)

const timeLeft = ref(0)
const itemLeft = ref(rest.value)

let lastSound = 0
let wasWork = false

onMounted(() => {
  backgroundTheme.value = BackgroundThemes.START
})

function close () {
  millesMem.value = 0
  pauseWorkout()
  router.back()
}

function resumeWorkout () {
  noSleep.enable()
  startTs.value = Date.now()
  interval.value = setInterval(fire, 10)
  isRunning.value = true
  // navigator.wakeLock.request('screen')
}

function pauseWorkout () {
  noSleep.disable()
  millesMem.value = millesMem.value + Date.now() - startTs.value
  isRunning.value = false

  clearInterval(interval.value)
}

function setBgColor () {
  let newBg = BackgroundThemes.START
  if (isRunning.value) {
    newBg = isWork.value ? BackgroundThemes.WORK : BackgroundThemes.REST
  }
  if (backgroundTheme.value !== newBg) backgroundTheme.value = newBg
}

function fire () {
  const exerciseLen = workMs.value + restMs.value
  const millisPassed = Date.now() - startTs.value + millesMem.value
  exerciseNum.value = Math.ceil(millisPassed / exerciseLen)
  const currExerciseMs = millisPassed % exerciseLen
  isWork.value = (currExerciseMs > restMs.value)

  let innerPerc = isWork.value
    ? (currExerciseMs - restMs.value) / workMs.value
    : currExerciseMs / restMs.value

  timeLeft.value = (totalTimeMs.value - millisPassed) / 1000
  itemLeft.value = isWork.value
    ? Math.ceil((workMs.value - currExerciseMs + restMs.value) / 1000)
    : Math.ceil((restMs.value - currExerciseMs) / 1000)

  if (millisPassed >= totalTimeMs.value) {
    clearInterval(interval.value)
    exerciseNum.value = exercises.value
    innerPerc = 1
    backgroundTheme.value = BackgroundThemes.FINAL
    tickFinal.play()
    return
  }

  for (const i of [1, 2, 3]) {
    if (itemLeft.value === i && lastSound !== i) {
      lastSound = i
      tickShort.play()
    }
  }

  if (isWork.value !== wasWork && innerPerc !== 1) {
    wasWork = isWork.value
    tickLong.play()
  }

  innerVal.value = innerPerc
  outerVal.value = millisPassed / totalTimeMs.value
  setBgColor()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", null, _toDisplayString(exerciseNum.value) + " / " + _toDisplayString(_unref(exercises)), 1),
    _createElementVNode("h2", null, _toDisplayString(_unref(time2Str)(timeLeft.value)), 1),
    _createVNode(TimerRings, {
      "inner-val": innerVal.value,
      "outer-val": outerVal.value,
      "is-work": isWork.value
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(time2Str)(itemLeft.value)), 1)
      ]),
      _: 1
    }, 8, ["inner-val", "outer-val", "is-work"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", { onClick: close }, "X"),
      (!isRunning.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: resumeWorkout
          }, "play"))
        : _createCommentVNode("", true),
      (isRunning.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: pauseWorkout
          }, "pause"))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})